import httpRequest from '../../../../../../modules/Gull/Framework/httpRequest.js';

const editView = {
	/**
	 * Init events en dom
	 *
	 * @returns {void}
	 */
	init() {
		editView.initEvents();

		// Trigger functies bij laden van de pagina
		if (document.getElementById('form-arbeidsovereenkomst')) {
			editView.toggleUitdienstDatum();
			editView.toggleParttimePercentage();
			editView.updateEinddatumRange();
			editView.checkOverlappendDienstverband();
		}
		editView.showModalBeeindiging();
	},

	/**
	 * Init de event listeners
	 *
	 * @returns {void}
	 */
	initEvents() {
		// Contract veld - Toon of verberg uitdienst datum
		['change', 'blur'].forEach((eventType) => {
			document.getElementById('Contract')?.addEventListener(eventType, () => {
				editView.toggleUitdienstDatum();
			});
		});

		// Dienstverband veld - Toon of verberg het percentage voor een parttime medewerker
		['change', 'blur'].forEach((eventType) => {
			document.getElementById('Dienstverband')?.addEventListener(eventType, () => {
				editView.toggleParttimePercentage();
			});
		});

		// Begindatum veld - Laad de datum kiezer voor einddatum op basis van de begindatum
		['change', 'blur'].forEach((eventType) => {
			document.getElementById('Begindatum')?.addEventListener(eventType, () => {
				editView.updateEinddatumRange();
			});
		});

		// Begindatum, Einddatum en Contract velden - Toon of verberg het blok voor overlappend dienstverband op basis van de begindatum voor een nieuw dienstverband en de einddatum van reeds bestaande dienstverbanden.
		['Begindatum', 'Einddatum', 'Contract'].forEach((field) => {
			['change', 'blur', 'input'].forEach((eventType) => {
				document.getElementById(field)?.addEventListener(eventType, () => {
					editView.checkOverlappendDienstverband();
				});
			});
		});

		// Beeindigingsmelding knop - Toon of verberg beindigingsmodal
		document.getElementById('beeindig-melding-button')?.addEventListener('click', (event) => {
			event.preventDefault();
			editView.toggleModalBeeindigingMelding(event);
		});

		// Vul suggestie verlengdatum in
		document.querySelectorAll('.btn-verlengdatum')?.forEach((button) => {
			button.addEventListener('click', (event) => {
				editView.verlengdatumSuggestie(event);
			});
		});
	},

	/**
	 * Toont of verbergt het einddatum veld op basis van het contract type
	 *
	 * @returns {void}
	 */
	toggleUitdienstDatum: function () {
		const einddatumInput = document.querySelector('input#Einddatum');
		const contractValue = document.querySelector('#Contract').value;
		if ('BEP' === contractValue) {
			einddatumInput.setAttribute('data-validate', 'required date daterange');
			einddatumInput.value = einddatumInput.getAttribute('valueOrg');
			einddatumInput.closest('.form-group').classList.remove('d-none');
			einddatumInput.dispatchEvent(new Event('update.datepicker'));
		} else {
			einddatumInput.value = '';
			einddatumInput.setAttribute('data-validate', '');
			einddatumInput.closest('.form-group').classList.add('d-none');
		}
	},

	/**
	 * Toont of verbergt het parttime percentage veld op basis van het dienstverband type
	 *
	 * @returns {void}
	 */
	toggleParttimePercentage: function () {
		const percentageInput = document.querySelector('input#ParttimePercentage');
		const dienstverbandValue = document.querySelector('#Dienstverband').value;
		if ('PT' === dienstverbandValue) {
			percentageInput.setAttribute('data-required', 'true');
			percentageInput.value = percentageInput.getAttribute('valueOrg');
			percentageInput.closest('.form-group').classList.remove('d-none');
			percentageInput.focus();
		} else {
			percentageInput.removeAttribute('data-required');
			percentageInput.value = '100';
			percentageInput.closest('.form-group').classList.add('d-none');
		}
	},

	/**
	 * Werkt de einddatum datepicker bij op basis van de startdatum
	 *
	 * @returns {void}
	 */
	updateEinddatumRange: function () {
		const target = document.querySelector('input#Einddatum');
		const begindatum = document.querySelector('input#Begindatum');
		target.setAttribute('data-enddate', begindatum.getAttribute('data-enddate'));
		target.setAttribute('data-startdate', begindatum.value);
		$(target).datepicker('setEndDate', begindatum.getAttribute('data-enddate'));
		$(target).datepicker('setStartDate', begindatum.value);
	},

	/**
	 * Controleert op overlappende arbeidsovereenkomsten op basis van start- en einddatum
	 *
	 * @returns {void}
	 */
	checkOverlappendDienstverband: function () {
		if ('' !== document.getElementById('Begindatum').value) {
			const werknemer_id = document.getElementById('form-arbeidsovereenkomst').getAttribute('data-werknemer_id');
			const dienstverband_arbeidsovereenkomst_id = document.getElementById('form-arbeidsovereenkomst').getAttribute('data-dienstverband_arbeidsovereenkomst_id');
			const begindatum = document.getElementById('Begindatum').value;
			const einddatum = document.getElementById('Einddatum').value;
			const url = window.app.ajaxPath + werknemer_id + '/' + dienstverband_arbeidsovereenkomst_id + '/duplicate-check/' + begindatum + '/' + einddatum + '/' + dienstverband_arbeidsovereenkomst_id + '/';
			httpRequest.get(url, editView.checkOverlappendDienstverbandParseResponse);
		}
	},

	/**
	 * Parses the response from checking for overlapping employment contracts
	 *
	 * @param {Array|boolean} data - Array of overlapping contract IDs or false if no overlap
	 *
	 * @returns {void}
	 */
	checkOverlappendDienstverbandParseResponse: function (data) {
		data = JSON.parse(data);
		if (data && data.length > 0) {
			editView.handleOverlappendDienstverband(data);
		} else {
			editView.handleGeenOverlappendDienstverband();
		}
	},

	/**
	 * Handelt het geval af wanneer overlappende arbeidsovereenkomsten worden gevonden
	 * Toont overlap waarschuwing en verbergt formulier voortzetting sectie terwijl actie links worden getoond
	 *
	 * @param {Array<string>} data - Array van overlappende contract IDs
	 *
	 * @returns {void}
	 */
	handleOverlappendDienstverband: function (data) {
		document.getElementById('form_suggestion')?.classList.remove('d-none');
		document.getElementById('form_continue')?.classList.add('d-none');
		data.forEach(function (id) {
			let rows = document.querySelectorAll('.table-arbeidsovereenkomsten tr[data-dienstverband_arbeidsovereenkomst_id="' + id + '"]');
			rows.forEach(function (row) {
				let linkContainers = row.querySelectorAll('td a');
				linkContainers.forEach(function (link) {
					link.classList.remove('d-none');
					link.closest('td').classList.remove('d-none');
				});
			});
		});
	},

	/**
	 * Handelt het geval af wanneer geen overlappende arbeidsovereenkomsten worden gevonden
	 * Verbergt actie links, overlap waarschuwing en toont formulier voortzetting sectie
	 *
	 * @returns {void}
	 */
	handleGeenOverlappendDienstverband: function () {
		const allRows = document.querySelectorAll('.table-arbeidsovereenkomsten tr');
		allRows.forEach(function (row) {
			row.classList.remove('text-danger');
			let links = row.querySelectorAll('a');
			links.forEach(function (link) {
				link.classList.add('d-none');
			});
			let linkContainer = row.querySelector('a');
			if (linkContainer) {
				linkContainer.closest('td').classList.add('d-none');
			}
		});
		document.getElementById('form_suggestion')?.classList.add('d-none');
		document.getElementById('form_continue')?.classList.remove('d-none');
	},

	/**
	 * Toont of verbergt de beëindigingsmodal op basis van overlappende arbeidsovereenkomsten
	 *
	 * @param {Event} event - Het klik event object
	 *
	 * @returns {void}
	 */
	toggleModalBeeindigingMelding: function (event) {
		const url = event.target.getAttribute('href');
		httpRequest.get(url, editView.toggleModalBeeindigingMeldingParseResponse);
	},

	/**
	 * Parse de response van de beëindigingsmelding
	 *
	 * @param {string} data - De response data
	 *
	 * @returns {void}
	 */
	toggleModalBeeindigingMeldingParseResponse: function (data) {
		if (false !== data) {
			data = JSON.parse(data);
			const modal = document.getElementById('modalBeeindigMelding');
			const bsModal = bootstrap.Modal.getInstance(modal) || new bootstrap.Modal(modal);
			bsModal.hide();
		}
	},

	/**
	 * Toont de beëindigingsmodal als er een lopende melding is
	 *
	 * @returns {void}
	 */
	showModalBeeindiging: function () {
		const modal = document.getElementById('modalBeeindigMelding');
		if (modal) {
			const bsModal = new bootstrap.Modal(modal);
			bsModal.show();
		}
	},

	/**
	 * Vult de voorgestelde verlengdatum in als gebruiker op 'Vul hieronder deze datum in' klikt
	 *
	 * @param {Event} event - Het klik event object
	 *
	 * @returns {void}
	 */
	verlengdatumSuggestie: function (event) {
		const verlengdatum = event.target.dataset.verlengdatum;
		const begindatumInput = document.querySelector('input[name=Begindatum]');
		if (begindatumInput) {
			begindatumInput.value = verlengdatum;
			begindatumInput.dispatchEvent(new Event('blur'));
		}
	},
};

export default editView;
